import { Link } from '@shared/router';
import { ROUTES } from '@shared/constants';

export function NotFoundPage() {
  return (
    <div className="flex min-h-[60vh] items-center justify-center">
      <div className="text-center">
        <h1 className="text-disabled text-9xl font-bold">404</h1>
        <h2 className="text-medium-emphasis mb-4 text-3xl font-semibold">Page Not Found</h2>
        <p className="text-medium-emphasis mb-8">
          The page you&apos;re looking for doesn&apos;t exist or has been moved.
        </p>
        <Link
          to={ROUTES.HOME}
          className="bg-primary hover:bg-primary inline-block rounded-lg px-8 py-3 font-medium text-white shadow-lg transition-colors"
        >
          Go Home
        </Link>
      </div>
    </div>
  );
}
